<template>
  <v-chip :color="chipColor" text-color="black" small class="text-uppercase font-weight-medium glass-effect-chip" label>
    {{ priority }}
  </v-chip>
</template>

<script>
import PRIORIDAD from '@/modules/notificaciones/domain/prioridad'

export default {
  props: {
    priority: {
      type: String,
      required: true,
      validator: (value) => {
        return Object.values(PRIORIDAD).includes(value)
      },
    },
  },

  computed: {
    chipColor() {
      switch (this.priority) {
        case PRIORIDAD.BAJA:
          return 'blue'
        case PRIORIDAD.MEDIA:
          return 'amber darken-2'
        case PRIORIDAD.ALTA:
          return 'orange darken-3'
        case PRIORIDAD.URGENTE:
          return 'red'
        default:
          return 'grey'
      }
    },
  },
}
</script>

<style scoped>
.glass-effect-chip {
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.18) !important;
  box-shadow: 0 4px 12px 0 rgba(31, 38, 135, 0.25) !important;
  transition: all 0.3s ease !important;
}

.glass-effect-chip:hover {
  box-shadow: 0 8px 16px 0 rgba(31, 38, 135, 0.37) !important;
  transform: translateY(-1px);
}

.glass-effect-chip.v-chip.v-chip--small {
  border-radius: 16px;
  font-weight: 500 !important;
  letter-spacing: 0.5px;
  padding: 0 12px !important;
}

/* Customize colors with glass effect */
.glass-effect-chip.v-chip.blue {
  background: linear-gradient(135deg, rgba(33, 150, 243, 0.85), rgba(33, 150, 243, 0.65)) !important;
  border: 1px solid rgba(33, 150, 243, 0.3) !important;
}

.glass-effect-chip.v-chip.amber.darken-2 {
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.85), rgba(255, 193, 7, 0.65)) !important;
  border: 1px solid rgba(255, 193, 7, 0.3) !important;
}

.glass-effect-chip.v-chip.orange.darken-3 {
  background: linear-gradient(135deg, rgba(255, 152, 0, 0.85), rgba(255, 152, 0, 0.65)) !important;
  border: 1px solid rgba(255, 152, 0, 0.3) !important;
}

.glass-effect-chip.v-chip.red {
  background: linear-gradient(135deg, rgba(244, 67, 54, 0.85), rgba(244, 67, 54, 0.65)) !important;
  border: 1px solid rgba(244, 67, 54, 0.3) !important;
}

.glass-effect-chip.v-chip.grey {
  background: linear-gradient(135deg, rgba(158, 158, 158, 0.85), rgba(158, 158, 158, 0.65)) !important;
  border: 1px solid rgba(158, 158, 158, 0.3) !important;
}
</style>
